import { render, staticRenderFns } from "./LabReport.vue?vue&type=template&id=294a8777"
import script from "./LabReport.vue?vue&type=script&lang=js"
export * from "./LabReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports